import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { documentText } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { preventPageScroll } from '../../../utilities/preventPageScroll.util'
import { setShowModal } from '../store/fillablePDFs.actions'
import { useDispatch } from 'react-redux'

const FillablePDFButton: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const showFillablePDFsModal = () => {
    preventPageScroll(true)
    dispatch(setShowModal(true))
  }

  return (
    <IonButton
      data-testid='FillablePDFs'
      className='scan-drivers-license-button'
      expand='block'
      fill='clear'
      onClick={() => showFillablePDFsModal()}
      color='primary-alt'>
      <IonIcon icon={documentText} size='large' />
      {t('fillablePDFs.pdfAttachment')}
    </IonButton>
  )
}

export default FillablePDFButton
